import { render, staticRenderFns } from "./pbbsettle.vue?vue&type=template&id=c2df33d4"
import script from "./pbbsettle.vue?vue&type=script&lang=js"
export * from "./pbbsettle.vue?vue&type=script&lang=js"
import style0 from "./pbbsettle.vue?vue&type=style&index=0&id=c2df33d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports